/**
 * Hook to monitor network connectivity status
 * Updates offline sync store when network status changes
 */

import { useEffect } from 'react'
import { useOfflineSyncStore } from '@/stores/offlineSyncStore'

export function useNetworkStatus() {
  const setOnline = useOfflineSyncStore((state) => state.setOnline)
  const isOnline = useOfflineSyncStore((state) => state.isOnline)

  useEffect(() => {
    const handleOnline = () => {
      setOnline(true)
    }

    const handleOffline = () => {
      setOnline(false)
    }

    // Set initial state
    setOnline(navigator.onLine)

    // Listen for network status changes
    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [setOnline])

  return { isOnline }
}

